import { Box, Typography } from '@material-ui/core';

export const TaskFooter = ({
  classes,
  remainingCount = 0,
  onAccept,
  isSaving = false,
  onClose,
}: {
  classes: Record<string, string>;
  remainingCount?: number;
  onAccept?: () => void;
  isSaving?: boolean;
  onClose?: () => void;
}) => {
  return (
    <Box className={classes.footer}>
      <Typography className={classes.footerHelperText} style={{ maxWidth: 480 }}>
        {remainingCount > 0
          ? `Flags are advisory — you can submit now and resolve the remaining ${remainingCount} item${remainingCount === 1 ? '' : 's'} later.`
          : 'All items verified — you can submit now.'}
      </Typography>
      <Box className={classes.dashboardActions}>
        <button type="button" className={classes.skipButton} onClick={onClose}>
          Skip For now
        </button>
        {onAccept && (
          <button type="button" className={classes.acceptButton} onClick={onAccept} disabled={isSaving}>
            Accept Track Record
          </button>
        )}
      </Box>
    </Box>
  );
};
